module.exports = __webpack_public_path__ + "img/person2.0c84afa6.jpg";